import { RootState } from '../../store';
import { SectorEnum } from '../../store/fundamental/types';

const ETFS_SECTOR_ID = 9;
export const ETF_SECTOR_NAME = 'ETFs';

export const getAllSectors = (state: RootState) => {
  let sectors = state.fundamental.sectors;
  const gappersCount = state.fundamental.gappersData.totalElements;
  const gappers = { sector: SectorEnum.Gappers, symbolCount: gappersCount };
  sectors = [ gappers, ...state.fundamental.sectors ];

  const etfCount = state.fundamental.ETFData.totalElements;
  const etf = { id: ETFS_SECTOR_ID, sector: ETF_SECTOR_NAME, symbolCount: etfCount };
  return [ etf, ...sectors ];
};
